import { WidgetsParcelClaimMain } from '@/widgets/parcel-claim';

export const PagesParcelClaimMain = () => <WidgetsParcelClaimMain />;
